import { Component } from "solid-js";

interface JewelleryIconProps {
  class?: string;
}

export const JewelleryIcon: Component<JewelleryIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3147 18.6667C18.4427 18.6667 19.2 19.6601 19.2 20.5854C19.2 22.4627 16.0574 24.0001 16 24.0001C15.9427 24.0001 12.8 22.4627 12.8 20.5854C12.8 19.6601 13.5574 18.6667 14.6854 18.6667C15.3307 18.6667 15.7547 18.9681 16 19.2374C16.2454 18.9681 16.6694 18.6667 17.3147 18.6667Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9999 16.0001V19.2401"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 27.9961C9.11066 27.9961 3.44266 22.7708 2.74132 16.0681C2.66532 15.3388 3.17999 14.6788 3.90666 14.5908C8.29333 14.0561 11.54 10.6441 11.9533 5.20277C12.0053 4.5201 12.596 4.00277 13.28 4.00543L16 4.01343L18.72 4.0041C19.4053 4.00143 19.996 4.5201 20.0467 5.20277C20.46 10.6441 23.7067 14.0548 28.092 14.5908C28.82 14.6801 29.336 15.3401 29.2587 16.0708C28.5573 22.7721 22.888 27.9961 16 27.9961Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.9587 12.1374C21.308 14.4761 18.824 16.0001 16 16.0001"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.04126 12.1374C10.6919 14.4761 13.1759 16.0001 15.9999 16.0001"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
